var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

exports.pbkdf2 = require('./lib/async');
exports.pbkdf2Sync = require('./lib/sync');